var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.url),expression:"url"}],staticClass:"imgs"}),_c('Suspension',{attrs:{"bottom":"36px","desc":"回首页","img":"http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home.svg"},on:{"share":_vm.goHome}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }